import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";
import authBaseQuery from "./authBaseQuery";

export const AUTH_API_REDUCER_KEY = "authApi";
export const authApi = createApi({
  reducerPath: AUTH_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["auth"],
  endpoints: (builder) => ({
    getSession: builder.query({
      query: () => ({
        url: "auth/admin/session",
      }),
      providesTags: ["auth"],
    }),
    login: builder.mutation({
      query: (body) => {
        return {
          url: "auth/admin/login",
          method: "POST",
          body,
        };
      },
      // invalidatesTags: ["auth"],
    }),
    supplierLogin: builder.mutation({
      query: (body) => {
        return {
          url: "auth/supplier/login",
          method: "POST",
          body,
        };
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: "auth/admin/logout",
        method: "POST",
      }),
      invalidatesTags: ["auth"],
    }),
  }),
});

export const NEW_AUTH_API_REDUCER_KEY = "newAuthApi";
export const newAuthApi = createApi({
  reducerPath: NEW_AUTH_API_REDUCER_KEY,
  baseQuery: authBaseQuery,
  tagTypes: ["auth"],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => {
        return {
          url: "/core/user/login",
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const { useLoginMutation, useLogoutMutation, useGetSessionQuery } =
  authApi;

export const { useLoginMutation: useNewLoginMutation } = newAuthApi;
